module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGb6a0965efa92e62207e3257893233066.b6a0965e.png";